if (document.getElementsByClassName("tbo-meta-json").length <= 0) {

    var tboShop = typeof Shopify !== 'undefined' ? Shopify.shop : document.domain;

    var tboShopDomain = document.domain;

    var tboBasePath = 'https://' + tboShopDomain + '/a/blkord/';

    var tboStorePath = window.location.pathname;

    $tbojobject = window.jQuery;

    var tboIsProduct = $tbojobject(".tech-dignity-snippet-bulk-order").attr('data-page');
    if (tboIsProduct === null || tboIsProduct === undefined){
        var tboIsProduct = tboStorePath.split('/')[1];
    }

    var tboIsCollectionProduct = tboStorePath.split('/')[3];

    var tboCurrentProductUrl = location.protocol + '//' + location.host + location.pathname;

    window.custom_properies = {};


    if (typeof jQuery == 'undefined') {

        var tboHead = document.getElementsByTagName('head')[0];

        var tboScript = document.createElement('script');

        tboScript.src = tboBasePath + 'js/lib/jquery-3.4.1.min.js';

        tboScript.type = 'text/javascript';      	

        tboScript.onreadystatechange = tboHandler;

        tboScript.onload = tboHandler;    

        // Fire the loading

        tboHead.appendChild(tboScript);

    }else{

        tboHandler();

    }



    function tboHandler(){
        
        $tbojobject = window.jQuery;

        var tboHead = document.getElementsByTagName('head')[0];

        // Load scripts function
        tboScripts();

        var tboAddBtn = $tbojobject('input[type=add], button[name=add], .tboCustomAdd');

        // Add Styles in head

        $tbojobject("head").append('<style type="text/css">.td-product-data{height: 250px;overflow: scroll;padding-bottom: 30px;margin-bottom: 20px;overflow-x: scroll;width: auto;}#tech-dignity-bulk-order .td-qty-box .td-inc-dec-button{cursor: pointer;width: 30px;float: left;text-align: center;background: #000;color: #fff;font-size: 20px;vertical-align: middle;}#tech-dignity-bulk-order .td-qty-box .decree{background-position: 0 -29px;}#tech-dignity-bulk-order input.td-product-qty{padding: 0px;width: 40px;height:40px;margin-left: 5px;margin-right: 5px;text-align: center;margin-bottom: 0px;line-height: 0px;}#tech-dignity-bulk-order .td-qty-box{display: flex;} .td-price,.td-variant-contents{margin-right:20px;margin-left:20px;width:100px;}.td-product-data .td-product-box{display:inline-flex;width:auto;border-bottom:1px solid #000;margin-bottom:20px}.td-image-box{width:100px}.td-variant-contents{width:150px;}td-price,.td-quantity{width:100px} .td-image-box img {display: inline-block;width: 100%;}span.tbooutofstock{color: #ff0000;font-weight: 800;vertical-align: middle;}</style>');



        // Check for comments

        if (tboIsProduct == "products" || (tboIsProduct == "collections" && tboIsCollectionProduct == 'products')) {

            var tboProductHandle = tboGetProductHandle(tboIsProduct,tboIsCollectionProduct);

            $tbojobject.get("/products/" + tboProductHandle + ".json", function (tboProductData) {

                // Get store settings

                var tboStoreSettings = tboGetStoreSetttings($tbojobject,tboProductData);            

                
                var tboStoreCurrency = '';

                if(tboStoreSettings){
                    
                    //console.log(tboStoreSettings);
                    tboStoreCurrency = tboStoreSettings.currency;

                    tboStoreSettings = tboStoreSettings.shopsetting;

                }

                var snippet = $tbojobject(".tech-dignity-snippet-bulk-order").length;



                // Check if app is enabled and display on product page

                if (tboStoreSettings.enable_app == 1 && (tboProductData.product.variants).length > 1) {

                    

                    // Get App Product Data and insert in shortcode

                    var tboAppDataWrapper = tboSetupAppDataWrapper($tbojobject, tboStoreSettings, tboProductData,tboStoreCurrency);

                    if(tboAppDataWrapper) {

                        var flag = 0;

                        if (tboStoreSettings.display_productpage == 1) {

                            // Insert the snippet before add to cart button

                            tboInsertAppSnippet($tbojobject);



                            // Load basic data

                            $tbojobject("#tech-dignity-bulk-order").append(tboAppDataWrapper.output);



                            // Enable other functions

                            flag = 1;

                        }  else {

                            if (snippet > 0) {

                                // Load basic data

                                $tbojobject(".tech-dignity-snippet-bulk-order").append('<div id="tech-dignity-bulk-order">'+tboAppDataWrapper.output+'</div>');                

                                // Enable other functions

                                flag = 1;

                            }

                        }

                        if (flag == 1) {

                            if (tboStoreSettings.show_hide_image == 1) {

                                // Load Images

                                tboLoadProductImages($tbojobject, tboProductData, tboAppDataWrapper.imageIds);

                            }



                            if (tboStoreSettings.show_hide_stock == 1) {

                                // Load Qty Params

                                tboLoadProductQty($tbojobject,tboAppDataWrapper.variantIds, tboProductData,tboStoreSettings);

                            }



                            // Remove Buy Now Button

                            $tbojobject('.shopify-payment-button').css({'display': 'none'});  



                            // Add To Cart

                            
                            
                            
                            $tbojobject(document).on("click",'input[type=add], button[name=add], .tboCustomAdd',function() {
                            
                            

                                var IsminQty = tboTotalQty($tbojobject, tboStoreSettings);
                            
                                
                            
                                if(IsminQty == false) {  
                                
                                    return false;

                                }	

                                $tbojobject.ajaxSetup({

                                    async: false

                                });

                                var length = $("#tech-dignity-bulk-order .td-qty-box").length;

                                var counter = 0;

                                $tbojobject("#tech-dignity-bulk-order .td-qty-box").each(function () {

                                    var qty = $tbojobject(this).find("input").val();

                                    var variant_id = $tbojobject(this).find("input").attr('variant_id');

                                    if (qty > 0) {

                                        var response = $tbojobject.post('/cart/add.js', {

                                            quantity: qty,

                                            id: variant_id,

                                            properties: custom_properies,

                                        })

                                    }

                                    counter++

                                });

                                if (counter == length) {

                                    var redirect_url = tboStorePath.split('/')[2];

                                    if(redirect_url == "products"){
                                        window.location.href = 'https://' + window.location.hostname + '/' + tboStorePath.split('/')[1] + '/cart'
                                    }else{
                                        window.location.href = 'https://' + window.location.hostname + '/cart'
                                    }


                                }

                                e.preventDefault()

                            });

                        }

                    }

                    // Get Dynamic Message
                    var dynamicQtyMsg = tboloadLanguage(tboStoreSettings,"dynamic_qty_msg");

                    // QTY Increment / Decrement

                    $tbojobject(document).on('click', '#tech-dignity-bulk-order .td-qty-box .td-inc-dec-button', function () {

                        var $button = $tbojobject(this);

                        var oldValue = $button.parent().find("input.td-product-qty").val();

                        if ($button.hasClass('tbo-increment')) {

                            var newVal = parseFloat(oldValue) + 1;

                        } else {

                            if (oldValue > 0) {

                                var newVal = parseFloat(oldValue) - 1;

                            } else {

                                newVal = 0

                            }

                        }

                        var current_stock_value = $tbojobject(this).parents('.td-quantity').find('.stock').attr('stock_data');

                        if (current_stock_value != "undefined") {
                            if (parseInt(newVal) > parseInt(current_stock_value)) {

                                var dynamicMsg = dynamicQtyMsg.replace('%S', current_stock_value);

                                if (dynamicQtyMsg != '') {

                                    alert(dynamicMsg);

                                }

                                newVal = current_stock_value

                            }

                        }

                        $button.parent().find("input").val(newVal)

                    });                            	

                

                    // Change QTY

                    $tbojobject(document).on('keyup', '.td-product-qty', function () {

                        var current_qty_box_value = $tbojobject(this).val();

                        var current_stock_value = $tbojobject(this).parents('.td-quantity').find('.stock').attr('stock_data');

                        if (current_stock_value != "undefined") {

                            if (parseInt(current_qty_box_value) > parseInt(current_stock_value)) {

                                var dynamicMsg = dynamicQtyMsg.replace('%S', current_stock_value);

                                if (dynamicQtyMsg != '') {

                                    alert(dynamicMsg);

                                }

                                $tbojobject(this).val(current_stock_value)

                            }

                        }

                    })

                }

            });

        }

    }

    // Load scripts
    function tboScripts(){

      // Api Script
      function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="${{amount}}",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var r=[];return jQuery.each(t,function(t,e){jQuery.each(e,function(e,a){r.push(t+" "+a)})}),r},Shopify.onCartUpdate=function(t){alert("There are now "+t.item_count+" items in the cart.")},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(r){return t}},Shopify.addItem=function(t,r,e){var r=r||1,a={type:"POST",url:"/cart/add.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(a)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:"/cart/add.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(t){jQuery.getJSON("/cart.js",function(r){"function"==typeof t?t(r):Shopify.onCartUpdate(r)})},Shopify.pollForCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var a=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(e,o,n){200===n.status?"function"==typeof r?r(e.shipping_rates,t):Shopify.onCartShippingRatesUpdate(e.shipping_rates,t):setTimeout(a,500)},error:e})};return a},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var a={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(a)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var a={type:"POST",url:"/cart/change.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(a)},Shopify.removeItem=function(t,r){var e={type:"POST",url:"/cart/change.js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(t){var r={type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(r){"function"==typeof t?t(r):Shopify.onCartUpdate(r)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(r)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:"/cart/update.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var e="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var a=attributeToString(r.key);""!==a&&(e+="attributes["+a+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){e+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var a={type:"POST",url:"/cart/update.js",data:e,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(a)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},jQuery.fn.jquery>="1.4"?Shopify.param=jQuery.param:(Shopify.param=function(t){var r=[],e=function(t,e){e=jQuery.isFunction(e)?e():e,r[r.length]=encodeURIComponent(t)+"="+encodeURIComponent(e)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){e(this.name,this.value)});else for(var a in t)Shopify.buildParams(a,t[a],e);return r.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(t,r,e){jQuery.isArray(r)&&r.length?jQuery.each(r,function(r,a){rbracket.test(t)?e(t,a):Shopify.buildParams(t+"["+("object"==typeof a||jQuery.isArray(a)?r:"")+"]",a,e)}):null!=r&&"object"==typeof r?Shopify.isEmptyObject(r)?e(t,""):jQuery.each(r,function(r,a){Shopify.buildParams(t+"["+r+"]",a,e)}):e(t,r)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});
        
    }

    function tboGetProductHandle(tboIsProduct,tboIsCollectionProduct){

        if (tboIsProduct == "collections" && tboIsCollectionProduct == 'products') {

            var tboSegmentArray = tboStorePath.split('/');

            var tboLastSegment = tboSegmentArray[tboSegmentArray.length - 1];

            return tboLastSegment;

        } else {

            var return_url = tboStorePath.split('/')[2];

            if(return_url == "products"){
                return tboStorePath.split('/')[3];
            }else{
                return tboStorePath.split('/')[2];
            }


        }

    }



    function tboGetStoreSetttings($tbojobject,tboProductData){

        var tboSettings = '';

        $tbojobject.ajax({

            url: "/index.json",
            async:false,
            data: {

                'view': 'tbo',

                'q': 'bulkorder',

                '_': '1626109880502'

            },
            success: function (tboSettingsData) {
                tboSettings = tboSettingsData.metafields.settings;
                //console.log(tboSettings);
            }

        });

        return tboSettings;

    }



    function tboInsertAppSnippet($tbojobject){

        $tbojobject("<div id='tech-dignity-bulk-order'></div>").insertBefore($tbojobject("form button[name='add']"));

        $tbojobject("<img class='td-add-cart-btn-roller' style='display:none;width:35px;' src='"+tboBasePath+"images/tbo_rolling_button.gif'>").insertAfter($("form button[name='add']"))

    }



    function tboSetupAppDataWrapper($tbojobject, tboStoreSettings, tboProductData, tboStoreCurrency){

        var tboOutput = '';

        var tboVariantIds = [];

        var tboImageIds = [];

        var result = [];

        var tboSectionTitle = tboloadLanguage(tboStoreSettings,"section_title");

        if (tboProductData.product.image == null) {

            var featured_img = tboBasePath + 'image/no-image.gif';

        } else {

            var featured_img = tboProductData.product.image.src;

        }

        if (tboStoreSettings.show_title == 1) {

            if (tboStoreSettings.section_title_font_size != null) {

            var tboSectionTitleColor = "font-size:" + tboStoreSettings.section_title_font_size + "px;"

            }

            tboOutput += '<h1 class="td-section-title" style="'+tboSectionTitleColor+'">' + tboSectionTitle + '</h1>';

        }

        tboOutput += '<div class="td-product-data">';



            $tbojobject.each(tboProductData.product.variants, function (key, value) {

                tboOutput += '<div class="td-product-box">';

                    // If Image is enabled

                    if (tboStoreSettings.show_hide_image == 1) {

                        tboOutput += '<div class="td-image-box">';

                            tboOutput += '<a href="' + tboCurrentProductUrl + '?variant=' + value.id + '" class="product-url" >';

                            if (value.image_id != null) {

                                tboOutput += '<img class="' + value.image_id + '" src="'+tboBasePath + 'images/loader.gif"/>'

                            } else {

                                var noImage = tboBasePath + 'images/no-image.gif';

                                tboOutput += '<img class="no-image" src="'+noImage+'"/>'

                            }

                            tboOutput += '</a>';

                        tboOutput += '</div>'

                    }

                    if (tboStoreSettings.product_title_color != null) {

                        var tboProTitleColor = "color:" + tboStoreSettings.product_title_color + ";"

                    }

                    if (tboStoreSettings.product_title_font_size != null) {

                        var tboProTitleFontSize = "font-size:" + tboStoreSettings.product_title_font_size + "px;"

                    }

                    tboOutput += '<div class="td-variant-contents">';

                    tboOutput += '<p><a href="' + tboCurrentProductUrl + '?variant=' + value.id + '">';

                    if (tboStoreSettings.show_variant_title == 1) {

                        tboOutput += '<span class="title" style="' + tboProTitleColor + tboProTitleFontSize + '">' + value.title + '</span>';

                    } else {

                        tboOutput += '<span class="title" style="' + tboProTitleColor + tboProTitleFontSize + '">' + tboProductData.product.title + '-' + value.title + '</span>';

                    }

                    tboOutput += '</a></p>';

            

                tboOutput += '</div>';



            
            
                // If Product Qty is enabled
                
                if (tboStoreSettings.show_hide_qty == 1) {

                if (tboStoreSettings.qyt_box_btn_color != null) {

                    var tboQtyBoxBtnColor = "background:" + tboStoreSettings.qyt_box_btn_color + ";";

                }

                tboOutput += '<div class="td-quantity">';

                if (tboStoreSettings.show_label == 1) {

                    var tboQtyTitle = tboloadLanguage(tboStoreSettings,"quantity_title");
                    tboOutput += '<span for="quanity" class="td-qty-label">' +tboQtyTitle+': </span>';

                }

                tboOutput += '<div class="td-qty-box"><div class="tbo-decrement decree td-inc-dec-button" style="' + tboQtyBoxBtnColor + '">-</div> <input type="text" variant_id="' + value.id + '" name="td_product_qty_' + value.id + '" position="' + value.position + '" class="td-product-qty" value="0"><div class="tbo-increment td-inc-dec-button" style="' + tboQtyBoxBtnColor + '">+</div></div>';

                if (tboStoreSettings.show_hide_stock == 1) {

                    tboOutput += '<p><span id="stock_' + value.id + '" class="stock" stock_data="" style="font-size:12px;"></span></p>';

                }

                tboOutput += '</div>';

                }

            

                var tboPriceFormat = '';
                
                if (tboStoreSettings.store_currency != null || tboStoreSettings.store_currency != "") {

                    tboPriceFormat = Shopify.formatMoney(value.price, tboStoreSettings.store_currency + ' {{amount}}')

                } else {

                    tboPriceFormat = Shopify.formatMoney(value.price)

                }

                
                // Check price want to show or not
            
                if (tboStoreSettings.show_hide_price == 1) {
                    
                tboOutput += '<div class="td-price">';

                if (tboStoreSettings.show_label == 1) {

                    var tboPriceTitle = tboloadLanguage(tboStoreSettings,"price_title");
                    tboOutput += '<span for="price">'+tboPriceTitle+':</span>';

                }

                if (tboStoreSettings.show_label == 1) {

                    tboOutput += '<p><span class="price">' + tboPriceFormat + '</span></p>';

                }

                tboOutput += '</div>';
            
                }
                tboOutput += '</div>';



                if (value.id != null) {

                    //tboVariantIds[key] = value.id;

                    tboVariantIds.push(value.id);

                }

                if (value.image_id != null) {

                    //tboImageIds[key] = value.image_id;

                    tboImageIds.push(value.image_id);

                }

            });

        tboOutput += '</div>';



        // Set Results in array

        result['output'] = tboOutput;

        result['variantIds'] = tboVariantIds;

        result['imageIds'] = tboImageIds;



        return result;

    }



    function tboLoadProductImages($tbojobject, tboProductData, imageIds) {

        $tbojobject.ajax({

            url: tboBasePath + "bulk_order_image",

            data: {

                shopname: tboShop,

                imageIds: imageIds.join(),

                productId: tboProductData.product.id,

            },

            success: function (data) {

                if(data){

                    var Images = $tbojobject.parseJSON(data);

                    $tbojobject.each(Images, function(index, value){

                        var imageId = value.imageId;

                        var imageUrl = value.imageUrl;

                        $tbojobject('.'+imageId).attr('src', imageUrl);

                    });

                }

            }

        })

    }



    function tboLoadProductQty($tbojobject, variantIds, tboProductData, tboStoreSettings) {  	

        $tbojobject.ajax({

            url: tboBasePath + "bulk_order_quantity",

            data: {

                shopname: tboShop,

                variantIds: variantIds.join(),

                productId: tboProductData.product.id,

            },

            success: function (data) {

                if(data){

                    var variantDetails = $tbojobject.parseJSON(data);
                    var tboOutOfStockText = tboloadLanguage(tboStoreSettings,"outstock_title");
                    var tboInStockText = tboloadLanguage(tboStoreSettings,"instock_title");

                    $tbojobject.each(variantDetails, function(index, variants){

                        $tbojobject.each(variants, function(indexNew, value){

                            if ((value.inventory_management == "shopify" && value.inventory_quantity > 0 || value.inventory_management == "shopify" && value.inventory_policy == "CONTINUE")) {

                                if ((value.inventory_management == "shopify" && value.inventory_policy == "CONTINUE")) {

                                    var qty = 1000;
                                    var qty_txt ='';

                                }else{

                                    var qty = value.inventory_quantity;
                                    var qty_txt = value.inventory_quantity;
                                }


                                $tbojobject(".td-quantity span#stock_" + value.id).text(qty_txt + tboInStockText);

                                $tbojobject(".td-quantity span#stock_" + value.id).attr('stock_data', qty)

                            } else if (value.inventory_management == null) {

                                $tbojobject(".td-quantity span#stock_" + value.id).text(tboInStockText);

                                $tbojobject(".td-quantity span#stock_" + value.id).attr('stock_data', null)

                            } else {
                            
                            if(tboStoreSettings.show_hide_stock == 1){
                                
                                $tbojobject("span#stock_" + value.id).parents(".td-quantity").addClass( "tbo-out-of-stock" );
                                $tbojobject("span#stock_" + value.id).parents(".td-quantity").html("<span class='tbooutofstock'><img src='https://bulkorder.prezenapps.com/public/images/out-of-stock-new.png' /></span>");
                                    
                            }else{
                                
                                $tbojobject(".td-quantity span#stock_" + value.id).text(tboOutOfStockText);
                                $tbojobject(".td-quantity span#stock_" + value.id).attr('stock_data', 0)
                            }

                            }

                        });

                    });

                }

            }

        })	

    }



    function tboTotalQty($tbojobject, tboStoreSettings) {

    

        var minQty = tboStoreSettings.min_qty;

        var maxQty = tboStoreSettings.max_qty;


        var qtyBox = $("#tech-dignity-bulk-order .td-qty-box");

        var totalQty = 0;

        

        jQuery.each(qtyBox, function(index, value){

            totalQty += parseInt(jQuery(this).find('.td-product-qty').val());

        });

    

        if (minQty == 0 && maxQty == 0) {

            return true;

        } else if (minQty == 0 && maxQty > 0) {

            if (totalQty <= maxQty) {

                return true;

            } else {

                var maxErrorMessage = tboloadLanguage(tboStoreSettings,"max_error_msg");

                alert(maxErrorMessage);

                return false;	

            }

        } else if (minQty > 0 && maxQty == 0) {

            if (totalQty >= minQty) {

                return true

            } else {

                var minErrorMessage = tboloadLanguage(tboStoreSettings,"min_error_msg");

                alert(minErrorMessage);

                return false;	

            }

        } else {

            if (totalQty >= minQty && totalQty <= maxQty) {

                return true

            } else {

                var qtyErrorMessage = tboloadLanguage(tboStoreSettings,"qty_error_msg");

                alert(qtyErrorMessage);

                return false;	

            }

        }      		  	

    }

    function tboloadLanguage(tboStoreSettings,tboNeededParam){
        var tboLanguage = $tbojobject('html').attr('lang');
        var tboLanguageData = {};
        var tboLanguageSettings = tboStoreSettings.shoplanguage;
        //console.log(tboStoreSettings);
        if(!tboLanguage || tboLanguage == ''){
           tboLanguage = $tbojobject('#tboLang').attr('lang');
        }
        //Checking if language has been created
        if(!tboLanguageSettings || tboLanguageSettings.length === 0){ //when no language created
          tboLanguageData['section_title'] = tboStoreSettings.section_title;
          tboLanguageData['qty_error_msg'] = tboStoreSettings.qty_error_msg;
          tboLanguageData['min_error_msg'] = tboStoreSettings.min_error_msg;
          tboLanguageData['max_error_msg'] = tboStoreSettings.max_error_msg;
          tboLanguageData['dynamic_qty_msg'] = tboStoreSettings.dynamic_qty_msg;
          tboLanguageData['price_title'] = "Price";
          tboLanguageData['quantity_title'] = "Quantity";
          tboLanguageData['instock_title'] = " In Stock";
          tboLanguageData['outstock_title'] = "Out Of Stock";
        }else{//when language has been created and active
          $tbojobject.each(tboLanguageSettings, function(tboLangIndex, tboLangVal) {
              if(tboLangIndex == tboLanguage){ //when language code match
                //console.log(tboLangVal);
                tboLanguageData['section_title'] = tboLangVal.section_title;
                tboLanguageData['qty_error_msg'] = tboLangVal.qty_error_msg;
                tboLanguageData['min_error_msg'] = tboLangVal.min_error_msg;
                tboLanguageData['max_error_msg'] = tboLangVal.max_error_msg;
                tboLanguageData['dynamic_qty_msg'] = tboLangVal.dynamic_qty_msg;
                tboLanguageData['price_title'] = tboLangVal.price_title;
                tboLanguageData['quantity_title'] = tboLangVal.quantity_title;
                tboLanguageData['instock_title'] = tboLangVal.instock_title;
                tboLanguageData['outstock_title'] = tboLangVal.outstock_title;
                return false;
              }else{//default setting when language not matched
                //console.log(tboLanguage);
                tboLanguageData['section_title'] = tboStoreSettings.section_title;
                tboLanguageData['qty_error_msg'] = tboStoreSettings.qty_error_msg;
                tboLanguageData['min_error_msg'] = tboStoreSettings.min_error_msg;
                tboLanguageData['max_error_msg'] = tboStoreSettings.max_error_msg;
                tboLanguageData['dynamic_qty_msg'] = tboStoreSettings.dynamic_qty_msg;
                tboLanguageData['price_title'] = "Price";
                tboLanguageData['quantity_title'] = "Quantity";
                tboLanguageData['instock_title'] = " In Stock";
                tboLanguageData['outstock_title'] = "Out Of Stock";
              }  
          });
        }
   
       //used when we need whole translation array
       if(tboNeededParam == "current_language"){
           return tboLanguageData;
       }
       return tboLanguageData[tboNeededParam];
     }
} 